import { Telescope,Zap } from "lucide-react";
import React from "react";
import { cn } from "src/common/utils";

import type { DigestReasoningType } from "../CreateDigestWizard/types";

interface ReasoningPickerProps {
  value: DigestReasoningType;
  onChange: (value: DigestReasoningType) => void;
}

const REASONING_OPTIONS: Array<{
  value: DigestReasoningType;
  label: string;
  description: string;
  icon: React.ElementType;
}> = [
  { value: "standard", label: "Moderate", description: "Best for routine digests", icon: Zap },
  { value: "advanced", label: "High", description: "Best for complex analysis", icon: Telescope },
];

export const ReasoningPicker: React.FC<ReasoningPickerProps> = ({ value, onChange }) => {
  return (
    <div className="flex gap-2">
      {REASONING_OPTIONS.map((option) => {
        const isSelected = value === option.value;
        const Icon = option.icon;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={cn(
              "flex items-center gap-2 rounded-md border px-3 py-2 text-sm transition-colors",
              isSelected
                ? "border-primary bg-primary/10 text-primary"
                : "border-border bg-background text-muted-foreground hover:border-primary/50 hover:text-foreground",
            )}
          >
            <Icon className="h-4 w-4" />
            <div className="text-left">
              <div className="font-medium">{option.label}</div>
              <div className="text-xs text-muted-foreground">{option.description}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
